// extracted by mini-css-extract-plugin
module.exports = {"button":"_3nd1j","active":"_3sRv5","text_active":"_5FExN"};